import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import heart from "../../../assets/img/heart_j.svg";
import heartFilled from "../../../assets/img/heartFilled.svg";
import download from "../../../assets/img/download_j.svg";
import flag from "../../../assets/img/flag_j.svg";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { FaStar, FaCheckCircle, FaChevronRight } from "react-icons/fa";
import TrendingUp from "@mui/icons-material/TrendingUp";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import RocketLaunchOutlined from "@mui/icons-material/RocketLaunchOutlined";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { hitJobListProfessionalApi } from "../../../Redux/Professional/JobListSlice";
import { hitSetBookMarkJobByProfessionalApi } from "../../../Redux/Professional/UpdateJobFavSlice";

import { showToast } from "../../../Helper/Toast";
import { timeAgo, getCorsSafeMediaUrl } from "../../../Helper/CommonFunctions";
import MapView from "./MapView";
import GoogleMapsWrapper from "./GoogleMapsWrapper";
import people from "../../../assets/img/people.svg";
import video from "../../../assets/img/video_icon.svg";
import refresh from "../../../assets/img/refresh_icon.svg";
import dot from "../../../assets/img/dot_icon.svg";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import JobResultModal from "./JobResultModal/JobResultModal";
import Loader from "../../Loader/Loader"; // adjust the path
import mapJobs from "../../../assets/img/Map jobs.svg";
import mapJobs1 from "../../../assets/img/map jobs 1.svg";
import listJobs from "../../../assets/img/list jobs.svg";
import listJobs1 from "../../../assets/img/list jobs 1.svg";
import BrowseAvailableJobs from "../../../assets/img/Browse Available Jobs.svg";
import searchFilter from "../../../assets/img/Search Filters.svg";
import jobFrofileIcon from "../../../assets/img/job frofile icon.svg";
import locations from "../../../assets/img/location jobs.svg";
import timeJobs from "../../../assets/img/time jobs.svg";
import rtgjobs from "../../../assets/img/rtg jobs.svg";
import searchIcon from "../../../assets/img/searchIcon.svg";
import bids from "../../../assets/img/bids jobs 1.svg";
import views from "../../../assets/img/views Jobs.svg";
import credits from "../../../assets/img/credits jobs.svg";
import ConcernsIcon from "../../../assets/img/Concerns icon.svg";
import Pagination from "../../Common/Pagination/Pagination";
import moment from "moment";
import { ApiBaseUrl } from "../../../Utils/Constants";

/** Below Bootstrap `xl` (1200px), use compact mobile browse chrome. */
const isStackedJobsLayout = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(max-width: 1199.98px)").matches;

const JOB_MEDIA_PLACEHOLDER =
  "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400";
const USER_PLACEHOLDER =
  "https://randomuser.me/api/portraits/men/32.jpg";

const getImageUrl = (imagePath) => {
  if (!imagePath || typeof imagePath !== "string") {
    return "";
  }

  if (/^(https?:)?\/\//i.test(imagePath) || imagePath.startsWith("data:")) {
    return imagePath;
  }

  const normalizedBaseUrl = ApiBaseUrl.endsWith("/")
    ? ApiBaseUrl.slice(0, -1)
    : ApiBaseUrl;
  const normalizedImagePath = imagePath.startsWith("/")
    ? imagePath
    : `/${imagePath}`;

  return `${normalizedBaseUrl}${normalizedImagePath}`;
};

const handleImageError = (event, fallbackSrc) => {
  if (event.currentTarget.src !== fallbackSrc) {
    event.currentTarget.src = fallbackSrc;
  }
};

const getJobCardCategoryLabel = (job) => {
  if (!job) return "General";
  const direct =
    job.serviceName ||
    job.tradeName ||
    job.jobCategoryName ||
    job.categoryName ||
    job.tenderTypeName;
  if (direct && String(direct).trim()) return String(direct).trim();
  if (Array.isArray(job.concerns) && job.concerns.length > 0) {
    const first = String(job.concerns[0] || "").trim();
    if (first) return first;
  }
  return "General";
};

const formatJobCardBudgetText = (job) => {
  if (job?.budgetMinimum === null) return "No Budget";
  if (job?.budgetMinimum === job?.budgetMaximum) {
    return `$${Number(job.budgetMaximum || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
  const min = Number(job?.budgetMinimum || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const max = Number(job?.budgetMaximum || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `$${min} - $${max}`;
};

const Job = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [location, setLocation] = useState("");
  const [jobType, setJobType] = useState(0);
  const [loading, setLoading] = useState(true);

  const locationHook = useLocation();
  const pathSegments = locationHook.pathname.split("/").filter(Boolean);
  const lastSegment = pathSegments[pathSegments.length - 1];

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 1;
  const [totalJobs, setTotalJobs] = useState(0);

  const [jobListData, setJobListData] = useState([]);

  const [selectedMapView, setSelectedMapView] = useState(false);

  const [budgetMaximum, setBudgetMaximum] = useState(100000);
  const [budgetMinimum, setBudgetMinimum] = useState(0);

  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("1");
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const [mobileSortOpen, setMobileSortOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      // navigation("/professional/login");
    } else {
      if (lastSegment === "saved-jobs") {
        // Saved Jobs
        dispatch(hitJobListProfessionalApi({ search: "", isBookmarked: 1 }));
      } else {
        dispatch(hitJobListProfessionalApi({ search: "" }));
      }
    }
  }, []);

  const updateBookmark = (jobId, isBookmark) => {
    dispatch(
      hitSetBookMarkJobByProfessionalApi({
        jobId: jobId,
        type: isBookmark === 1 ? 0 : 1,
      })
    ).then((res) => {
      if (res.payload && res.payload.status === true) {
        if (isBookmark === 1) {
          showToast("Job removed from bookmarks", "success");
        } else {
          showToast("Job bookmarked successfully", "success");
        }
        setJobListData((prevJobs) =>
          prevJobs.map((job) =>
            job._id === jobId
              ? { ...job, isBookmark: isBookmark === 1 ? 0 : 1 } // toggle locally
              : job
          )
        );
      }
    });
  };

  // Redux state
  const responseJobListProfessional = useSelector(
    (state) => state.jobListProfessionalReducer.data
  );

  useEffect(() => {
    if (responseJobListProfessional?.status === true) {
      setLoading(false);
      const list = responseJobListProfessional.data || [];
      setJobListData(list);
      setTotalJobs(responseJobListProfessional.count || 0);

    }
  }, [responseJobListProfessional]);

  const clickOnListView = () => {
    setSelectedMapView(false);
  };

  const clickOnMapView = () => {
    setSelectedMapView(true);
  };

  const applyFilters = (e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    setMobileSortOpen(false);
    if (budgetMinimum > budgetMaximum) {
      showToast(
        "Maximum budget should be greater than minimum budget",
        "error"
      );
      return;
    }
    setLoading(true);

    const searchObj = {
      search: search,
      location: location,
      budgetMinimum: budgetMinimum,
      budgetMaximum: budgetMaximum,
      sortBy: sortBy,
    };

    if (jobType != 0) {
      //console.log("enter jobType not equal to 0");
      searchObj.isReadyToGo = jobType;
      if (jobType == 3) {
        searchObj.isBookmarked = 1;
        delete searchObj.isReadyToGo;
      }
    } else {
      delete searchObj.isReadyToGo;
      delete searchObj.isBookmarked;
    }
    if (lastSegment === "saved-jobs") {
      searchObj.isBookmarked = 1;
    }
    dispatch(hitJobListProfessionalApi(searchObj));
  };

  const clearFilters = (e) => {
    e.preventDefault();
    setSearch("");
    setLocation("");
    setJobType(0);
    setSortBy("1");
    setBudgetMinimum(0);
    setBudgetMaximum(100000);
    setFiltersExpanded(false);
    setMobileSortOpen(false);
    if (lastSegment === "saved-jobs") {
      // Saved Jobs
      dispatch(hitJobListProfessionalApi({ search: "", isBookmarked: 1 }));
    } else {
      dispatch(hitJobListProfessionalApi({ search: "" }));
    }
  };

  const handleViewDetails = (job) => {
    navigation(`/professional/job-details/${job._id}`);
  };

  const handleSubmitBid = (job) => {
    navigation(`/professional/job-details/${job._id}?focus=bid`);
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [showJobBrowsingWelcome, setShowJobBrowsingWelcome] = useState(() => {
    try {
      return localStorage.getItem("sr_jobBrowsingWelcomeDismissed") !== "1";
    } catch {
      return true;
    }
  });

  const dismissJobBrowsingWelcome = () => {
    setShowJobBrowsingWelcome(false);
    try {
      localStorage.setItem("sr_jobBrowsingWelcomeDismissed", "1");
    } catch {
      /* ignore */
    }
  };

  const totalPages = Math.ceil(totalJobs / dataPerPage);

  const handleNext = () => {
    // move to next modal step
    if (step < 3) {
      setStep((prev) => prev + 1);
    } else {
      // if step 3 is done, close modal
      setModalOpen(false);
      setStep(1);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
    setStep(1);
  };

  const renderFiltersExpandedBody = () => (
    <div className="filters-card-expanded-body">
      <div className="filters-row">
        <div className="filter-item">
          <label>Job Title or Keywords</label>
          <input
            type="text"
            placeholder="e.g. Software Engineer, Designer"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <img src={searchIcon} alt="" style={{ bottom: 12 }} />
        </div>

        <div className="filter-item">
          <label>Location</label>
          <input
            type="text"
            placeholder="City, State"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
          <img
            src={locations}
            alt=""
            style={{ bottom: "14px" }}
          />
        </div>

        <div className="filter-item">
          <label>Job Type</label>
          <select
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
          >
            <option value="0">All Types</option>
            <option value="1">RTG</option>
            <option value="2">Non RTG</option>
          </select>
          <img src={timeJobs} alt="" />
        </div>

        <div className="filter-item">
          <label>Sort By</label>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="1">Newest</option>
            <option value="2">Oldest</option>
          </select>
          <img src={timeJobs} alt="" />
        </div>
      </div>

      <div className="budget-row">
        <Row className="align-items-end">
          <Col md={6}>
            <label>
              Budget Range: ${budgetMinimum} - ${budgetMaximum}
            </label>
            Min - ${budgetMinimum}
            <input
              type="range"
              min={0}
              max={100000}
              value={budgetMinimum}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value <= budgetMaximum) {
                  setBudgetMinimum(value);
                } else {
                  setBudgetMinimum(budgetMaximum);
                }
              }}
            />
          </Col>

          <Col md={6} className="mt-2 mt-md-0">
            Max - ${budgetMaximum}
            <input
              type="range"
              min={0}
              max={100000}
              value={budgetMaximum}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= budgetMinimum) {
                  setBudgetMaximum(value);
                } else {
                  setBudgetMaximum(budgetMinimum);
                }
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="total_count_bottom">
        <h6>Total Jobs- {totalJobs}</h6>
        <div className="actions">
          <button type="button" className="clear" onClick={(e) => clearFilters(e)}>
            Clear Filters
          </button>
          <button type="button" className="apply" onClick={(e) => applyFilters(e)}>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );


  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  const stacked = isStackedJobsLayout();

  const listingResultsHint =
    lastSegment === "saved-jobs"
      ? "Showing saved jobs"
      : search.trim() ||
          location.trim() ||
          Number(jobType) !== 0 ||
          Number(budgetMinimum) > 0 ||
          Number(budgetMaximum) < 100000 ||
          String(sortBy) === "2"
        ? "Showing filtered results"
        : "Showing results for all jobs";

  return (
    <div
      className={[
        "browse-jobs pro-app-page",
        stacked ? "browse-jobs--stacked" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="custom_container">
        {showJobBrowsingWelcome &&
          lastSegment !== "saved-jobs" && (
            <div className="job-browsing-welcome">
              <button
                type="button"
                className="job-browsing-welcome__close"
                aria-label="Dismiss welcome message"
                onClick={dismissJobBrowsingWelcome}
              >
                ×
              </button>
              <div className="job-browsing-welcome__head">
                <div className="job-browsing-welcome__brand-icon" aria-hidden>
                  <svg viewBox="0 0 32 32" width="20" height="20" fill="none">
                    <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2" />
                    <circle cx="16" cy="16" r="9" stroke="currentColor" strokeWidth="2" />
                    <circle cx="16" cy="16" r="4" fill="currentColor" />
                  </svg>
                </div>
                <div className="job-browsing-welcome__head-text">
                  <h2 className="job-browsing-welcome__title">
                    Welcome to Job Browsing!
                  </h2>
                  <p className="job-browsing-welcome__subtitle">
                    Find the perfect renovation projects for your business
                  </p>
                </div>
              </div>

              <div className="job-browsing-welcome__pro-tip">
                <div className="job-browsing-welcome__pro-tip-top">
                  <div className="job-browsing-welcome__bulb-wrap" aria-hidden>
                    <LightbulbOutlined sx={{ fontSize: 20, color: "#166534" }} />
                  </div>
                  <span className="job-browsing-welcome__pro-tip-label">Pro tip</span>
                  <span className="job-browsing-welcome__rocket" aria-hidden>
                    <RocketLaunchOutlined sx={{ fontSize: 20, color: "#dc2626" }} />
                  </span>
                </div>
                <p className="job-browsing-welcome__pro-tip-body">
                  Look for Ready to Go jobs. These clients are serious about starting
                  their project!
                </p>
              </div>

              <div className="job-browsing-welcome__footer">
                <div className="job-browsing-welcome__footer-left">
                  <span className="job-browsing-welcome__footer-dot" aria-hidden />
                  <span className="job-browsing-welcome__footer-meta">
                    {totalJobs}{" "}
                    {totalJobs === 1 ? "job" : "jobs"} available
                  </span>
                  <span className="job-browsing-welcome__footer-live">
                    <TrendingUp sx={{ fontSize: 16, color: "#16a34a" }} />
                    <span>Updated realtime</span>
                  </span>
                </div>
                <button
                  type="button"
                  className="job-browsing-welcome__got-it"
                  onClick={dismissJobBrowsingWelcome}
                >
                  Got It
                  <FaChevronRight className="job-browsing-welcome__got-it-arrow" aria-hidden />
                </button>
              </div>
            </div>
          )}

        {!stacked && (
        <div className="header">
          <div className="title">
            <img src={BrowseAvailableJobs} alt="Browse Available Jobs" />
            <span>
              Browse Available {lastSegment === "saved-jobs" ? "Saved" : ""}{" "}
              Jobs
            </span>
          </div>
          <div className="view-options">
            <button
              type="button"
              className={`map-btn ${selectedMapView ? "active" : ""}`}
              onClick={() => clickOnMapView()}
            >
              {selectedMapView ? (
                <img
                  src={mapJobs1}
                  alt=""
                  style={{ margin: "0 8px 4px 0" }}
                />
              ) : (
                <img
                  src={mapJobs}
                  alt=""
                  style={{ margin: "0 8px 4px 0" }}
                />
              )}
              Map
            </button>
            <button
              type="button"
              className={`list-btn ${!selectedMapView ? "active" : ""}`}
              onClick={() => clickOnListView()}
            >
              {selectedMapView ? (
                <img
                  src={listJobs1}
                  alt=""
                  style={{ margin: "0 8px 4px 0" }}
                />
              ) : (
                <img
                  src={listJobs}
                  alt=""
                  style={{ margin: "0 8px 4px 0" }}
                />
              )}
              List
            </button>
          </div>
        </div>
        )}

        {!stacked && (
        <div
          className={`filters-card${filtersExpanded ? "" : " filters-card--collapsed"}`}
        >
          <div className="filters-card-controls">
            <div className="filters-card-controls-top">
              <div className="filters-header">
                <img
                  src={searchFilter}
                  alt=""
                  style={{ margin: "0 8px 2px 0" }}
                />
                Search Filters
              </div>
              <span className="filters-total-badge">
                Total Jobs — {totalJobs}
              </span>
            </div>
            <div className="filters-toggle-row">
              <button
                type="button"
                className="filters-toggle-btn"
                onClick={() => setFiltersExpanded((prev) => !prev)}
                aria-expanded={filtersExpanded}
              >
                {filtersExpanded ? "Hide filters" : "Show filters"}
              </button>
            </div>
          </div>

          {filtersExpanded && renderFiltersExpandedBody()}
        </div>
        )}

        {stacked && (
          <>
            <div className="jobs-mobile-hero-card">
              <h1 className="jobs-mobile-hero-title">
                Browse Available {lastSegment === "saved-jobs" ? "Saved " : ""}
                Jobs
              </h1>
              <p className="jobs-mobile-hero-sub">
                Find renovation projects that match your skills and expertise.
              </p>
              <div className="jobs-mobile-quick-search">
                <img src={searchIcon} alt="" />
                <input
                  type="search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="e.g. Kitchen renovation, Artificial grass..."
                  enterKeyHint="search"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      setMobileSortOpen(false);
                      applyFilters(e);
                    }
                  }}
                />
              </div>
              <div className="jobs-mobile-tool-row">
                <button
                  type="button"
                  className={`jobs-mobile-tool-btn ${!selectedMapView ? "active" : ""}`}
                  onClick={() => {
                    setMobileSortOpen(false);
                    clickOnListView();
                  }}
                >
                  <img src={!selectedMapView ? listJobs1 : listJobs} alt="" />
                  <span>List</span>
                </button>
                <button
                  type="button"
                  className={`jobs-mobile-tool-btn ${selectedMapView ? "active" : ""}`}
                  onClick={() => {
                    setMobileSortOpen(false);
                    clickOnMapView();
                  }}
                >
                  <img src={selectedMapView ? mapJobs1 : mapJobs} alt="" />
                  <span>Map</span>
                </button>
                <button
                  type="button"
                  className={`jobs-mobile-tool-btn ${mobileSortOpen ? "active" : ""}`}
                  onClick={() => {
                    setFiltersExpanded(false);
                    setMobileSortOpen((open) => !open);
                  }}
                  aria-expanded={mobileSortOpen}
                >
                  <img src={timeJobs} alt="" />
                  <span>Sort</span>
                </button>
                <button
                  type="button"
                  className={`jobs-mobile-tool-btn ${filtersExpanded ? "active" : ""}`}
                  onClick={() => {
                    setMobileSortOpen(false);
                    setFiltersExpanded((prev) => !prev);
                  }}
                  aria-expanded={filtersExpanded}
                >
                  <img src={searchFilter} alt="" />
                  <span>Filters</span>
                </button>
              </div>
              {mobileSortOpen && (
                <div className="jobs-mobile-sort-sheet" role="group" aria-label="Sort jobs">
                  <button
                    type="button"
                    className={`jobs-mobile-sort-option ${String(sortBy) === "1" ? "is-selected" : ""}`}
                    onClick={() => {
                      setSortBy("1");
                      setMobileSortOpen(false);
                      applyFilters({ preventDefault: () => {} });
                    }}
                  >
                    Newest first
                  </button>
                  <button
                    type="button"
                    className={`jobs-mobile-sort-option ${String(sortBy) === "2" ? "is-selected" : ""}`}
                    onClick={() => {
                      setSortBy("2");
                      setMobileSortOpen(false);
                      applyFilters({ preventDefault: () => {} });
                    }}
                  >
                    Oldest first
                  </button>
                </div>
              )}
            </div>

            <div className="jobs-mobile-results-bar">
              <span className="jobs-mobile-results-count">
                {totalJobs} job{totalJobs === 1 ? "" : "s"} found
              </span>
              <span className="jobs-mobile-results-hint">{listingResultsHint}</span>
            </div>

            {filtersExpanded && (
              <div className="filters-card filters-card--mobile-expanded">
                {renderFiltersExpandedBody()}
              </div>
            )}
          </>
        )}

        {/* Previous Code start */}
        <Row>
          {selectedMapView && (
            <Col xs={12} className={`mb-5${stacked ? " jobs-mobile-map-col" : ""}`}>
              <GoogleMapsWrapper>
                <h4 className="fw-bold mt-4">Job Map View</h4>
                <MapView
                  markers={jobListData}
                  handleViewDetails={handleViewDetails}
                />
              </GoogleMapsWrapper>
            </Col>
          )}

          {jobListData.length === 0 && (
            <div
              className="no-jobs"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start", // align to top instead of center
                textAlign: "center",
                fontSize: "18px",
                color: "#666",
                height: "80vh", // keep consistent height
                paddingTop: "100px", // adjust this value as you like
              }}
            >
              No jobs found
            </div>
          )}

          {!selectedMapView && (
            <Col xs={12}>
              {jobListData.map((job) => (
                <div className="job-card" key={job._id || job.id}>
                  <div className="job-card-top">
                    <div className="job-card-top-row">
                      <div className="job-card-category">
                        <LocalOfferOutlined
                          className="job-card-category-icon"
                          sx={{ fontSize: 18 }}
                        />
                        <span>{getJobCardCategoryLabel(job)}</span>
                      </div>
                      <div className="job-card-head-actions">
                        {Number(job.isReadyToGo) === 1 && (
                          <span className="job-card-rtg-chip">
                            <img src={rtgjobs} alt="" />
                            RTG Job
                          </span>
                        )}
                        <button
                          type="button"
                          className="job-card-bookmark-btn"
                          aria-label={
                            job?.isBookmark === 1
                              ? "Remove bookmark"
                              : "Bookmark job"
                          }
                          onClick={() => {
                            updateBookmark(job?._id, job?.isBookmark);
                          }}
                        >
                          <img
                            src={job?.isBookmark === 1 ? heartFilled : heart}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <h3 className="job-card-title">{job.title}</h3>
                    <div className="job-card-meta-row">
                      <span className="job-card-meta-loc">
                        <img src={locations} alt="" />
                        {job.city}, {job.state}
                        <span className="job-card-meta-dot">·</span>
                        {job.isPlacedInYourServiceArea === 1
                          ? "In Area"
                          : "Out of Area"}
                      </span>
                      <span className="job-card-meta-time">
                        <img src={timeJobs} alt="" />
                        {timeAgo(job.createdAt)}
                      </span>
                    </div>
                  </div>

                  <div className="job-card-hero">
                    <img
                      src={
                        getCorsSafeMediaUrl(getImageUrl(job?.surfaceMeasurements?.[0]?.mediaItems?.[0])) ||
                        JOB_MEDIA_PLACEHOLDER
                      }
                      alt=""
                      onError={(event) =>
                        handleImageError(event, JOB_MEDIA_PLACEHOLDER)
                      }
                    />
                  </div>

                  <p className="job-card-description">{job.description}</p>

                  <div className="job-card-price-row">
                    <div
                      className={`job-card-price-value${
                        job.budgetMinimum === null
                          ? " job-card-price-value--muted"
                          : ""
                      }`}
                    >
                      {formatJobCardBudgetText(job)}
                    </div>
                    <div className="job-card-expiring">
                      Expiring:{" "}
                      {job.installedDateEnd &&
                      moment(job.installedDateEnd).isValid()
                        ? moment(job.installedDateEnd).format("MM/DD/YYYY")
                        : "—"}
                    </div>
                  </div>

                  <div className="job-card-client">
                    <img
                      src={
                        getCorsSafeMediaUrl(
                          getImageUrl(job.userId?.profileImage)
                        ) || USER_PLACEHOLDER
                      }
                      alt=""
                      className="job-card-client-avatar"
                      onError={(event) =>
                        handleImageError(event, USER_PLACEHOLDER)
                      }
                    />
                    <div className="job-card-client-text">
                      <span className="job-card-client-name">
                        {[job.userId?.firstName, job.userId?.lastName]
                          .filter(Boolean)
                          .join(" ") || "Client"}
                      </span>
                      <span className="job-card-client-loc">
                        {job.city} {job.state}
                      </span>
                    </div>
                  </div>

                  {/* {job.concerns && job.concerns.length > 0 && (
                    <>
                      <section className="job-card-concerns">
                        <span className="job-card-concerns-label">
                          <img src={ConcernsIcon} alt="" />
                          Concerns
                        </span>
                      </section>
                      <div className="job-card-tags">
                        {job.concerns.map((concern, index) => (
                          <span key={index}>{concern.trim()}</span>
                        ))}
                      </div>
                    </>
                  )} */}

                  <div className="job-card-stats-row">
                    <div className="job-card-stats-inline">
                      <span>
                        <img src={bids} alt="" />
                        {job.bidCount || 0}{" "}
                        {job.bidCount === 1 ? "bid" : "bids"}
                      </span>
                      <span>
                        <img src={views} alt="" />
                        {job.viewCount || 0}{" "}
                        {job.viewCount === 1 ? "view" : "views"}
                      </span>
                    </div>
                    <span className="job-stat-pill job-stat-pill--credits">
                      <img src={credits} alt="" />
                      {Number(job.isReadyToGo) === 1 ? 10 : 5} credits
                    </span>
                  </div>

                  <div className="job-actions">
                    <button
                      type="button"
                      className="details-btn"
                      onClick={() => handleViewDetails(job)}
                    >
                      View Details
                    </button>
                    <button
                      type="button"
                      className="bid-btn"
                      onClick={() => {
                        handleSubmitBid(job);
                      }}
                    >
                      {Number(job.isBidPlaced) === 1
                        ? "View My Bid"
                        : "Submit Your Bid"}
                    </button>
                  </div>
                </div>
              ))}

              {/* <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        /> */}
            </Col>
          )}
        </Row>

        {isModalOpen && step === 1 && (
          <JobResultModal
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default Job;
